import { useCallback } from "react";

import { useBuilderAccess } from "containers/admin/clients/touchpoint/components/builder/use-builder-access";
import { BuilderTabId } from "containers/admin/clients/touchpoint/components/builder/builder-tab-nav/builder-tab-nav";
import { useTouchpointLocking } from "contexts/touchpoint-locking-context";
import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";

interface UseHandleEditorOpenProps {
  selectedVersion?: TouchpointVersionAttributes;
  latestVersion?: TouchpointVersionAttributes | null;
}

export const useHandleEditorOpen = ({
  selectedVersion,
  latestVersion,
}: UseHandleEditorOpenProps) => {
  const { accessBuilder } = useBuilderAccess();
  const { setSelectedVersion } = useTouchpointLocking();

  const handleEditorOpen = useCallback(
    (tab?: BuilderTabId) => {
      // Always use the most up-to-date version information when opening the editor
      const version = (latestVersion || selectedVersion) as TouchpointVersionAttributes;
      setSelectedVersion(version);
      accessBuilder(version, tab);
    },
    [latestVersion, selectedVersion, setSelectedVersion, accessBuilder],
  );

  return { handleEditorOpen };
};
